import { type ReactNode } from 'react';
import { SectionListRowButtons, type SectionListRowButtonsProps } from './SectionListRowButtons';

export function SectionListRow({
	label,
	children,
	...props
}: {
	label: string | ReactNode;
	children?: ReactNode;
} & SectionListRowButtonsProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-gray-200">
			<div className="group flex items-center justify-between gap-3 bg-gray-100 px-3 py-2.5">
				{typeof label !== 'string' ? label : <span className="flex-1 text-sm font-medium text-gray-900">{label}</span>}
				<SectionListRowButtons {...props} />
			</div>
			{children && <div className="py-3 pl-7">{children}</div>}
		</div>
	);
}
